<template>
  <div id="header">
    <div class="header-w">
      <div class="header-info">
        <div class="logo-bar">
          <a href="">
            <img v-if="isRh" src="../assets/logo-rh.png" alt="">
            <img v-else src="../assets/logo.png" alt="">
          </a>
        </div>
        <div class="logo-bar second-logo">
          <a href="">
            <img v-if="logo" :src="logo" alt="">
          </a>
        </div>
        <div>
          <h1 v-html="title"></h1>
        </div>
      </div>
      <ul class="tools">
        <li v-if="!firefox" class="border-tools">
          <a v-tooltip="getTooltip($t('zoomOut'))" @click.prevent="$store.commit('zoomOut')" href="#">
            <img class="icon" src="../assets/icons/zoom-moins.svg" alt="">
          </a>
          <a v-tooltip="getTooltip($t('zoomIn'))" @click.prevent="$store.commit('zoomIn')" href="#">
            <img src="../assets/icons/zoom-plus.svg" alt="">
          </a>
        </li>
        <li>
          <a  v-if="pdf" download v-tooltip="getTooltip($t('pdfDownload'))" target="_blank" :href="pdf">
            <img src="../assets/icons/pdf.svg" alt="">
          </a>
          <a v-if="report" download v-tooltip="getTooltip($t('docDownload'))" :href="report">
            <img src="../assets/icons/document.svg" alt="">
          </a>
        </li>
        <li>
          <a target="_blank" v-tooltip="getTooltip($t('watchVideo'))" href="https://www.youtube.com/watch?v=r5qfwXz9iFU">
            <img src="../assets/icons/video.svg" alt="">
          </a>
          <a v-tooltip="getTooltip($t('howToRead'))" @click.prevent="toggleCaption()" href="#">
            <img src="../assets/icons/question.svg" alt="">
          </a>
          <a v-tooltip="getTooltip($t('contactUs'))" href="mailto:trackers@kpam.fr">
            <img src="../assets/icons/email-contact.svg" alt="">
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
function _imageEncode(arrayBuffer) {
  let u8 = new Uint8Array(arrayBuffer);
  let b64encoded = btoa(
    [].reduce.call(
      new Uint8Array(arrayBuffer),
      function(p, c) {
        return p + String.fromCharCode(c);
      },
      ""
    )
  );
  let mimetype = "image/jpeg";
  return "data:" + mimetype + ";base64," + b64encoded;
}
import api from "../api";
export default {
  props: {
    pdf: {
      type: String,
      default: null
    },
    report: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    isRh: {
      type: Boolean,
      default: false
    },
    logo: {
      type: String,
      default: null
    }
  },
  computed: {
    firefox() {
      return this.$store.getters.firefox;
    }
  },
  mounted() {},
  methods: {
    getTooltip(content) {
      return {
        container: "body",
        content
      };
    },
    changeLocale() {
      this.$i18n.set("fr");
    },
    toggleCaption() {
      if (document.getElementById("caption")) {
        document.getElementById("caption").classList.toggle("active");
        document.getElementById("trackers").classList.remove("active");
      }
    },
    toggleTrackers() {
      if (document.getElementById("trackers")) {
        document.getElementById("trackers").classList.toggle("active");
        document.getElementById("caption").classList.remove("active");
      }
    },
    zoom(delta) {
      document.getElementById("tracker").classList.toggle("zoom-out");
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
#header {
  height: 80px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 3;
  .header-w {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-info {
      display: flex;
      align-items: center;
      flex: 1;
      .logo-bar {
        img {
          width: 60px;
          height: auto;
          margin: 0 1em;
        }
      }
    }
    .tools {
      display: flex;
      align-items: center;
      justify-content: center;
      > li {
        border-right: 1px solid #e2e2e2;
        padding: 0 0.8em;
        display: flex;
        align-items: center;
        justify-content: center;
        &.border-tools {
          border-radius: 20px;
          border: 1px solid $darkGreen;
          padding: 0 7px;
          a {
            padding: 6px 10px;
          }
          a:last-child {
            position: relative;
            &::before {
              content: "";
              position: absolute;
              height: 100%;
              top: 0;
              left: 0;
              bottom: 0;
              width: 1px;
              background: $darkGreen;
            }
          }
        }
        &:last-child {
          border-right: none;
        }
        a {
          text-decoration: none;
          color: #000;
          display: inline-block;
          padding: 6px 8px;
          font-size: 1.2rem;
          cursor: pointer;
          img {
            display: block;
            margin: auto;
            width: 20px;
            height: auto;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 960px) {
  #header {
    height: auto;
    .header-w {
      display: block;
      .header-info {
        display: block;
        position: relative;
        h1 {
          text-align: center;
          padding: 1em 0;
        }
        .logo-bar {
          a {
            img {
              padding-top: 8px;
            }
          }
          &.second-logo {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
      .tools {
        padding: 1em 0;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  #header {
    .header-w {
      .header-info {
      }
      .tools {
        > li {
          padding: 0 0.5em;
          a {
            padding: 5px 5px;
            img {
              width: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
